<template>
    <div class="container bng-slots bng-narrow-container">
        <game-banner />
        <jackpots-bar v-if="jackpots && jackpots.length" />
        <slots-filter :on-filter="(slotCategory, sort, searchText) => filter(slotCategory, sort, searchText)" :showMenu="false" v-if="games.length > 12" />
        <game-list v-if="gamesFiltered.length" :games="gamesFiltered" />
    </div>
</template>

<script>
    import Vue from 'vue';

    import SlotsFilter from '../../../common/slots-filter/slots-filter.vue';
    import GameList from '../../../common/game-list/game-list.vue';
    import GameBanner from '../../../common/banners/game-banners/game-banner.vue';
    import JackpotsBar from '../../../common/jackpots/jackpots-bar/jackpots-bar.vue';

    export default {
        name: 'games',
        components: { SlotsFilter, GameList, JackpotsBar, GameBanner },
        props: {
            filters: {
                type: Array,
            }
        },
        data() {
            return {
                games: [],
                gamesFiltered: []
            };
        },
        computed: {
            player() {
                return Vue.state.player.get();
            },
            jackpots() {
                return (
                    (this.player &&
                        this.player.balance &&
                        this.player.activeJackpots) ||
                    []
                );
            }
        },
        watch: {
            "$route.name": function() {
                this.loadGames();
            }
        },
        created() {
            this.loadGames();
        },
        methods: {
            loadGames() {
                this.games = Vue.state.games.getByFilters(this.filters);
                this.filter('all', 'popularity', null);
            },
            filter(slotCategory, sort, searchText) {
                if (sort === 'alphabetically') {
                    this.games.sort((a, b) => a.gameId.localeCompare(b.gameId));
                } else if (sort === 'popularity') {
                    this.games.sort((a, b) => b.priority - a.priority);
                }

                this.gamesFiltered = searchText ? this.games.filter(s => s.gameId.indexOf(searchText) > -1) : this.games;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/games/games.vue